import type { Metadata } from 'next';

// Use the canonical production origin, never a request's Host header.
export const SITE_URL = 'https://speedmixr.com';
export function roomPath(slug: string) { return `/r/${encodeURIComponent(slug)}`; }
export function pageMetadata(title: string, description: string, path: string): Metadata {
  const url = `${SITE_URL}${path}`;
  return {
    title, description, alternates: { canonical: url },
    openGraph: { title, description, url, type: 'website', siteName: 'SpeedMixr' },
    twitter: { card: 'summary', title, description },
    robots: { index: true, follow: true },
  };
}
export function roomDescription(realm: { name: string; description: string | null }) {
  return (realm.description?.trim() || `Join ${realm.name} on SpeedMixr. Meet professionals in short one-to-one video conversations and build your network.`)
    .replace(/\s+/g, ' ').slice(0, 160);
}
